import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { BASE_URL } from 'common/constants';

export const addStudent = createAsyncThunk(
  'students/add',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/students`, data);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const filterStudents = createAsyncThunk(
  'student/filter',
  async (data, { rejectWithValue }) => {
    try {
      const response = await axios.post(`${BASE_URL}/students/filter`, data);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const fetchStudents = createAsyncThunk(
  'students/fetch',
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/students`);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const deleteStudent = createAsyncThunk(
  'students/delete',
  async (id, { rejectWithValue }) => {
    try {
      await axios.delete(`${BASE_URL}/students/${id}`);
      return id;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const showStudent = createAsyncThunk(
  'students/show',
  async (id, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/students/${id}`);
      return response.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);

export const updateStudent = createAsyncThunk(
  'students/update',
  async ({ id, formData }, { rejectWithValue }) => {
    console.log('AAAAAAAAAAAAAAAA', id);
    try {
      const response = await axios.patch(
        `${BASE_URL}/students/${id}`,
        formData
      );
      console.log('RESPONSE =>', response);
      return response.data;
    } catch (err) {
      console.log(err);
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  }
);
